import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import * as Sentry from '@sentry/angular';
import { environment } from '@env/environment';

if (environment.sentry !== undefined) Sentry.init(environment.sentry);
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
